import React, { useEffect } from "react";
import Config from "../../../../utils/Config";
import styles from "./index.module.scss";

var slideIndex = 0;
var slidesInterval = null;
var bPlayBanners = false;
function Banners() {
  //===========================================================================
  useEffect(() => {
    PreLoad();
    componentDidMount();
    return componentWillUnmount;
  }, []);
  useEffect(() => {
    let uiBannersContent = document.getElementById("bannersContent");

    let bannersContent = "";
    if (uiBannersContent) {
      if (Config.banners) {
        bannersContent = `<div class="${styles.slideshowContainer}">`;
        for (let iIndex = 0; iIndex < Config.banners.length; iIndex++) {
          const url = Config.banners[iIndex].url;
          const img = Config.banners[iIndex].img;
          const video = Config.banners[iIndex].video
            ? Config.banners[iIndex].video
            : "";
          const mp4 = Config.banners[iIndex].mp4
            ? Config.banners[iIndex].mp4
            : "";
          if (iIndex === 0)
            bannersContent += `<div class="${styles.mySlides}" style="display: block;">`;
          else
            bannersContent += `<div class="${styles.mySlides}" style="display: none;">`;

          bannersContent += `<div class="${styles.numbertext}">${
            iIndex + 1
          } / ${Config.banners.length}</div>`;
          if (url !== "") {
            bannersContent += `<a href="${url}" target="_blank">`;
          }
          if (img !== "") {
            bannersContent += `<img src="${img}" style="width: 100%;"></img>`;
          }
          if (video !== "") {
            bannersContent += '<div id="vd">';
            //bannersContent += `<iframe id="video${iIndex}" style="width: 100%; minHeight: 640px;"}></iframe>`;
            bannersContent += `<iframe  id="video${iIndex}"></iframe >`;
            bannersContent += "</div>";
          }
          if (mp4 != "") {
            bannersContent += '<div id="mp4">';
            bannersContent += `<video  controls id="video${iIndex}" style="width: 100%; maxHeight: 240px;"></video >`;
            bannersContent += "</div>";
          }
          if (url !== "") {
            bannersContent += "</a>";
          }
          //bannersContent += `<div class="${styles.text}"></div>`;
          bannersContent += `</div>`;
        }
        bannersContent += `</div>`;
        bannersContent += `<div>`;

        for (let i = 0; i < Config.banners.length; i++) {
          bannersContent += `<span class="${styles.dot}"></span>`;
        }
        bannersContent += `</div>`;
      }

      uiBannersContent.innerHTML = bannersContent;

      if (Config.banners) {
        for (let i = 0; i < Config.banners.length; i++) {
          const videoSource = Config.banners[i].video
            ? Config.banners[i].video
            : "";
          const mp4Source = Config.banners[i].mp4 ? Config.banners[i].mp4 : "";
          const gameVideoId = `video${i}`;
          const uiGameVideo = document.getElementById(gameVideoId);
          if (uiGameVideo && videoSource) {
            const keyWord = "://";
            let index = videoSource.indexOf(keyWord);
            if (index >= 0)
              videoSource = videoSource.substr(index + keyWord.length);

            let strParams = videoSource.split("/");
            let videoDomain = strParams[0];
            index = videoDomain.indexOf(":");
            if (index >= 0) videoDomain = videoDomain.substr(0, index);

            // rebuild video source
            let videoUrl = `${videoDomain}`;
            for (let i = 1; i < strParams.length; i++) {
              videoUrl += `/${strParams[i]}`;
            }

            strParams = videoUrl.split("/");
            let videoId = strParams[strParams.length - 1];
            let url = `http://${videoDomain}/?id=${videoId}`;
            url += "&autostart=true&muted=true";

            uiGameVideo.src = url;
            uiGameVideo.style.display = "";
            uiGameVideo.style.objectFit = "fill";
            //處理自動撥放,iOS的部分就是把下面參數放到SRS html的<video></video>裡面即可

            uiGameVideo.setAttribute("playsinline", null);
            uiGameVideo.setAttribute("WebKitPlaysInline", null);
            //uiGameVideo.controls = "controls";
            //uiGameVideo.controls = "false";
            uiGameVideo.autoplay = "autoplay";
            uiGameVideo.WebKitPlaysInline = true;
            uiGameVideo.playsinline = true;
            uiGameVideo.preload = "auto";
            uiGameVideo.muted = "true";
          } else if (uiGameVideo && mp4Source) {
            let url = mp4Source;
            url += "?loop=true";
            uiGameVideo.src = url;
            uiGameVideo.style.display = "";
            uiGameVideo.style.objectFit = "fill";
            //處理自動撥放,iOS的部分就是把下面參數放到SRS html的<video></video>裡面即可

            uiGameVideo.setAttribute("playsinline", null);
            uiGameVideo.setAttribute("WebKitPlaysInline", null);
            //uiGameVideo.controls = "controls";
            //uiGameVideo.controls = "false";
            uiGameVideo.autoplay = "autoplay";
            uiGameVideo.WebKitPlaysInline = true;
            uiGameVideo.playsinline = true;
            uiGameVideo.preload = "auto";
            uiGameVideo.muted = "true";
            uiGameVideo.loop = "true";
          }
        }
      }

      if (Config.banners) {
        if (Config.banners.length >= 1) bPlayBanners = true;
      }

      if (bPlayBanners) {
        slidesInterval = setInterval(showSlides, 5000);
        showSlides();
      }
    }
  }, []);
  //===========================================================================
  function PreLoad() {}

  function componentDidMount() {
    // Change image every 2 seconds
    // if(bPlayBanners)
    // {
    //     slidesInterval = setInterval(showSlides, 5000);
    //     showSlides();
    // }
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {
    if (slidesInterval) {
      clearInterval(slidesInterval);
      slidesInterval = null;
      bPlayBanners = false;
    }
  }

  function showSlides() {
    if (!bPlayBanners) return;
    var i;
    var slides = document.getElementsByClassName(styles.mySlides);
    var dots = document.getElementsByClassName(styles.dot);
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    slideIndex++;
    if (slideIndex > slides.length) {
      slideIndex = 1;
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(` ${styles.active}`, "");
    }
    slides[slideIndex - 1].style.display = "block";
    dots[slideIndex - 1].className += ` ${styles.active}`;
  }

  return (
    <div id="banners" className={styles.bannersPanel}>
      <div id="bannersContent"></div>
    </div>
  );
}

// {/*
// <div id="bannersContent">
//             </div>
//         <div className={styles.slideshowContainer} style={{marginTtop:"10px"}}>
//                 <div className={styles.mySlides} style={{display:"block;"}}>
//                     <div className={styles.numbertext}>1 / 4</div>
//                     <img src="img/loginpage/Banner_01.jpg" style={{width:"100%"}}></img>
//                     <div claclassNamess={styles.text}></div>
//                 </div>
//                 <div className={styles.mySlides} style={{display:"none;"}}>
//                     <div className={styles.numbertext}>2 / 4</div>
//                     <img src="img/loginpage/Banner_02.jpg" style={{width:"100%"}}></img>
//                     <div className={styles.text}></div>
//                 </div>
//                 <div className={styles.mySlides} style={{display:"none;"}}>
//                     <div className={styles.numbertext}>3 / 4</div>
//                     <img src="img/loginpage/Banner_03.jpg" style={{width:"100%"}}></img>
//                     <div className={styles.text}></div>
//                 </div>
//                 <div className={styles.mySlides} style={{display:"none;"}}>
//                     <div className={styles.numbertext}>4 / 4</div>
//                     <img src="img/loginpage/Banner_04.jpg" style={{width:"100%"}}></img>
//                     <div className={styles.text}></div>
//                 </div>
//             </div>
//             <div>
//                 <span className={styles.dot}></span>
//                 <span className={styles.dot}></span>
//                 <span className={styles.dot}></span>
//                 <span className={styles.dot}></span>
//             </div> */}
export default Banners;
